module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown--dark-341672d83e6a9b653abe66e76560a111.png";